import { action, makeObservable, observable } from 'mobx';
import { ViewModel } from '../interfaces/ViewModel';
import { ISearchTrait } from '../interfaces/ISearchTrait';
import { isViewModel } from '../helpers/isViewModel';
import { IModelConstructor } from '../interfaces/IModelConstructor';
import { handler, makeMetadata, property } from '../helpers/decorators';

export function withSearch<T extends ViewModel = ViewModel>(Base: IModelConstructor<T>): IModelConstructor<ISearchTrait<T> & T> {
  const BaseClass = Base as unknown as typeof ViewModel;

  if (!isViewModel(BaseClass)) {
    throw new Error('[VM]: This mixin can only decorate view model');
  }

  class WithSearch extends BaseClass implements ISearchTrait<T> {
    constructor(...args: any[]) {
      super(...args);
      makeObservable(this);
      makeMetadata(this);
    }

    /**
     * 获取当前VM的筛选项列表
     * @example
     */
    @property
    @observable
    filters: object = {};

    /**
     * 更新当前VM的filters信息
     * @param filters
     */
    @action
    setFilters(filters: object): this {
      this.filters = filters;
      return this;
    }

    @handler
    @action
    onFiltersChange(filters: object) {
      this.setFilters(filters);
    }
  }

  return WithSearch as unknown as IModelConstructor<ISearchTrait<T> & T>;
}
